import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {IndexConfigService} from "./index.config.service";

@Injectable()
export class MfaService {
  constructor(public http: HttpClient,
              public config: IndexConfigService) {
  }

  public setupUrl(type: string) {
    return this.config.api + '/api/mfa/' + type + '/setup';
  }

  public disableUrl() {
    return this.config.api + '/api/mfa/disable';
  }

  initSetup(type: string) {
    return this.http.get(this.setupUrl(type), {responseType: 'text'});
  }

  completeSetup(type: string, code: string) {
    return this.http.post<any>(this.setupUrl(type), {code: code});
  }

  initDisable() {
    return this.http.get<any>(this.disableUrl());
  }

  completeDisable(code: string) {
    return this.http.post<any>(this.disableUrl(), {code: code});
  }
}
